import { has, isObject } from 'lodash'

export interface GetAccountEncryptedDataOutput {
  /* eslint-disable @typescript-eslint/naming-convention */
  MaskedPrefixCell: string
  MaskedCell: string
  UserPnr: string
  /* eslint-enable @typescript-eslint/naming-convention */
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const isGetAccountEncryptedDataOutput = (obj: any): obj is GetAccountEncryptedDataOutput => {
  const maskedPrefixCell = 'MaskedPrefixCell'
  const maskedCell = 'MaskedCell'
  const userPnr = 'UserPnr'
  return isObject(obj) && has(obj, maskedPrefixCell) && has(obj, maskedCell) && has(obj, userPnr)
}
